module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAArElEQVRIx2N4zCVOI8QwavQAG/3Syefbpm1/nj0HIiADyKWO0R9qW/7//fvvx88PNc3P9a2eSqi+8gh6m5JDqdFABwLN/f/nzys3fxQpXqnnRrZPBGWfiCqSaTTQ+/////8ydxGm0qfSGk8l1YAKnspqvnIPJNloYOACjX6bkIGp9LmO+efJM0Fh9eXrcz1LGhj979+/r9/IMZqGAULDaKRh4qNtlhktnoae0QCFLqqTaGfd3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/tr.png
// module id = 939
// module chunks = 0